module.exports = __webpack_public_path__ + "static/media/ajustes.0ea9783e.svg";